// @ts-check
import React from "react";
import { AccionDrawer, AccionSistema } from "./SideBar";
import "./Pies.scss";
import { Calendar, Filter, LogOut, RefreshCw, Server, ServerOff } from "lucide-react";
import { useMainContext } from "../MainContext";

/**
 * @returns {JSX.Element}
 */
function Pies() {
  const { state, syncLista } = useMainContext();
  return (
    <div id="Pies">
      <AccionDrawer componente={0}>
        <Calendar size={30} color="white" />
      </AccionDrawer>
      <AccionDrawer componente={1}>
        <Filter size={30} color="white" />
      </AccionDrawer>
      {state.estudios.error ? (
        <AccionSistema>
          <ServerOff size={30} color="white" />
        </AccionSistema>
      ) : (
        <AccionSistema>
          <Server size={30} color="white" />
        </AccionSistema>
      )}
      <AccionSistema
        onClick={syncLista}
        girar={state.estudios.sync}
      >
        <RefreshCw size={30} color="white" />
      </AccionSistema>
      <AccionSistema>
        <LogOut size={30} color="white" />
      </AccionSistema>
    </div>
  );
}

export default Pies;
